import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "NewsPostComment",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { postNewsComment, postNewsCommentError, postNewsCommentSuccess } =
  slice.actions;

reducerRegistry.register("newsPostComment", reducer);
